import { render, staticRenderFns } from "./QuestionConfigTextInput.vue?vue&type=template&id=e7f1efd2&scoped=true"
import script from "./QuestionConfigTextInput.vue?vue&type=script&lang=js"
export * from "./QuestionConfigTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f1efd2",
  null
  
)

export default component.exports